/**
 * Created by Christof Sander on 06.12.2016.
 */

const utils = require('../lib/utils');

// list of functions named by sanitizerID which can then be used to sanitize data on the server.
// NOTE:    the get-sanitizers are reachable via getSanitize method, the set-sanitizers are reachable by the setSanitizer method and
//          the component-sanitizers are used for component- instead of resource-routes and are reachable by the componentSanitzer method.
var sanitizers = {
	component: {},
	preGet: {},
	preDataStructure: {},
	get: {},
	set: {}
};

// NOTE: this sanitizers will overwrite all definitions from outside for security reasons!
var defaultSanitizers = {
	component: {
		// TODO: CLEANUP
		// /**
		//  * filter section components and layouts from the given data.
		//  *
		//  * @param resources
		//  * @param resourceConfig
		//  * @param storage
		//  * @return {*}
		//  */
		// routeWithoutLayoutAndSectionComponents: function(resources, resourceConfig, storage){
		//
		// }
	},

	preGet: {},

	preDataStructure: {

		/**
		 * in some cases a query may be faster if the data will be gathered within one single json field instead of multiple rows.
		 * this sanitizer is used to normalize this format for compatibility reasons.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @returns {{data}}
		 */
		rawQuerySingleRowSelector: function(resources, resourceConfig, storage){
			var wrapperData = (resources || {}).data || [];
			if(wrapperData.length === 1){
				var dataContainer = wrapperData[0] || {};
				var result = {};
				if(dataContainer.data){
					result.data = dataContainer.data;
				}
				if(dataContainer.meta){
					result.meta = dataContainer.meta;
				}
				return result;
			}
			return resources;
		},
	},

	get: {
		/**
		 * limit resources to privilege, status and visibility-periods within the first attribute level.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @return {*}
		 */
		statusPrivilegePeriod: function(resources, resourceConfig, storage){
			var deletionCounter = 0;
			var dataIndex;
			var dataLength = resources.data.length;
			var resource;

			for(dataIndex = 0; dataIndex < dataLength; dataIndex++){
				resource = resources.data[dataIndex-deletionCounter];

				// TODO: check scope issue
				if(
					!storage.user.hasAccessTo(resource.attributes.privilegeCode, resource.attributes.scope)
					||
					!storage.user.statusVisible(resource.attributes.status)
					||
					(
						resource.attributes.periodStart
						&&
						resource.attributes.periodStart != null
						&&
						storage.user.getReferenceTS() >= resource.attributes.periodStart
					)
					||
					(
						resource.attributes.periodEnd
						&&
						resource.attributes.periodEnd != null
						&&
						storage.user.getReferenceTS() <= resource.attributes.periodEnd
					)
				){
					resources.data.splice((dataIndex-deletionCounter), 1);
					deletionCounter++;
				}
			}

			return resources;
		},

		/**
		 * limit resources to status and visibility-periods within the first attribute level.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @return {*}
		 */
		statusPeriod: function(resources, resourceConfig, storage){
			var deletionCounter = 0;
			var dataIndex;
			var dataLength = resources.data.length;
			var resource;

			for(dataIndex = 0; dataIndex < dataLength; dataIndex++){
				resource = resources.data[dataIndex-deletionCounter];

				// TODO: check scope issue
				if(
					!storage.user.statusVisible(resource.attributes.status)
					||
					(
						resource.attributes.periodStart
						&&
						resource.attributes.periodStart != null
						&&
						storage.user.getReferenceTS() >= resource.attributes.periodStart
					)
					||
					(
						resource.attributes.periodEnd
						&&
						resource.attributes.periodEnd != null
						&&
						storage.user.getReferenceTS() <= resource.attributes.periodEnd
					)
				){
					resources.data.splice((dataIndex-deletionCounter), 1);
					deletionCounter++;
				}
			}

			return resources;
		},

		/**
		 * limit route-picker-data to privilege, status, visibility periods and navigation-route options
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 */
		statusPrivilegePeriodNavigation: function(resources, resourceConfig, storage) {
			var deletionCounter;
			var resource;
			var excludedRouteIDs = [];
			var scopeInheritanceInCharge = false;
			var r, routes = {};

			// TODO: scope inheritance between subTrees and the parentTree-leafs?

			// create route data mapping
			for(r in (resources || {}).data || []){
				routes[((resources.data[r] || {}).attributes || {})[(resources.data[r] || {}).primaryKey || 'routeID']] = (resources.data[r] || {}).attributes || {};
			}

			// scope inheritance
			do {
				scopeInheritanceInCharge = false;
				for(r in (resources || {}).data || []){
					if(!(resources.data[r].attributes || {}).scope && (resources.data[r].attributes || {}).parentRouteID && routes[(resources.data[r].attributes || {}).parentRouteID] && routes[(resources.data[r].attributes || {}).parentRouteID].scope){
						scopeInheritanceInCharge = true;
						(resources.data[r].attributes || {}).scope = routes[(resources.data[r].attributes || {}).parentRouteID].scope;
					}
				}
			} while(scopeInheritanceInCharge);

			// exclude routes according to its' parameters
			do {
				deletionCounter = 0;

				for(r in (resources || {}).data || []){
					resource = resources.data[r - deletionCounter].attributes || {};

					if (
						excludedRouteIDs.indexOf(resource.parentRouteID) >= 0
						|| !storage.user.hasAccessTo(resource.privilegeCode, resource.scope)
						|| !storage.user.statusVisible(resource.status)
						||
						(
							resource.periodStart
							&&
							resource.periodStart != null
							&&
							storage.user.getReferenceTS() >= resource.periodStart
						)
						||
						(
							resource.periodEnd
							&&
							resource.periodEnd != null
							&&
							storage.user.getReferenceTS() <= resource.periodEnd
						)
						||
						(
							!resource.isVisibleInNavigation
						)
					) {
						excludedRouteIDs.push(resource.routeID);
						resources.data.splice((r - deletionCounter), 1);
						deletionCounter++;
					}
				}

				// change detected? to prevent errors according to the resource-entries' order repeat this sanitize logic until nothing has to be excluded from this list.
			} while (deletionCounter > 0);

			return resources;
		},

		/**
		 * limit routes used within html replacements according to privilege, status and visibility periods
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @return {*}
		 */
		htmlReplacementRouteFilter: function(resources, resourceConfig, storage){
			// var deletionCounter;
			// var dataIndex;
			// var dataLength;
			// var resource;
			var deletionPerformed;
			var excludedRouteIDs = [];

			do {
				deletionPerformed = false;
				// deletionCounter = 0;
				// dataLength = resources.length;

				utils.forEach(resources, function(routeData, routeID){
				// for (dataIndex = 0; dataIndex < dataLength; dataIndex++) {
				// 	resource = resources[dataIndex - deletionCounter];

					if (
						utils.indexOf(excludedRouteIDs, routeData.parentRouteID) >= 0
						|| !storage.user.hasAccessTo(routeData.privilegeCode, routeData.scope)
						|| !storage.user.statusVisible(routeData.status)
						||
						(
							routeData.periodStart
							&&
							routeData.periodStart != null
							&&
							storage.user.getReferenceTS() >= routeData.periodStart
						)
						||
						(
							routeData.periodEnd
							&&
							routeData.periodEnd != null
							&&
							storage.user.getReferenceTS() <= routeData.periodEnd
						)
					) {
						excludedRouteIDs.push(routeID);
						delete resources[routeID];
						// resources.splice((dataIndex - deletionCounter), 1);
						// deletionCounter++;
						deletionPerformed = true;
					}
				});

			// change detected? to prevent errors according to the resource-entries' order repeat this sanitize logic until nothing has to be excluded from this list.
			} while (deletionPerformed);

			return resources;
		},

		/**
		 * this function is used to sanitize the routesCache which will be built when the service-auth call is done.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @return {{}}
		 */
		routesCache: function(resources, resourceConfig, storage){
			var result = {};
			var routeData;

			utils.forEach(resources && resources.data ? resources.data : [], function(route){
				if(route.attributes){
					routeData = route.attributes;
					if(routeData.path && routeData.routeID){
						result[routeData.routeID] = routeData;
					}
				}
			});

			return result;
		},
		
		/**
		 * this function is used to sanitize the validatorsCache which will be built when the service-auth call is done.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @return {{}}
		 */
		validatorsCache: function(resources, resourceConfig, storage){
			var result = {};
			var validatorData, internal, code, langCode;

			utils.forEach(resources && resources.data ? resources.data : [], function(validator){
				if(validator.attributes && (code = validator.attributes.code)){
					validatorData = validator.attributes;

					internal = undefined;
					validatorData.messages = {};

					if(validator.relationships && validator.relationships.cms_validatorsTrl){
						utils.forEach(validator.relationships.cms_validatorsTrl.data || [], function(validatorTrl){
							if(validatorTrl.attributes && (langCode = validatorTrl.attributes.langCode)){
								validatorData.messages[langCode] = validatorTrl.attributes.message;
							}
						});
					}

					if(result[code]){
						console.error('validator code used multiple times: ' + code);
					}
					else {
						result[code] = validatorData;
					}
				}
			});

			return result;
		},

		/**
		 * this sanitizer is used to perform all necessary preparations to get a useful resource-structure out of
		 * the data loaded by the 'menus'-resourceTemplate and reduce the response data to a necessary minimum.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @returns {{data: [
		 * 	{
		 * 		attributes: <categoryDataAttributes>,
		 * 		primaryKey: "categoryDataID",
		 * 		children: {
		 * 			cms_routes: {
		 * 				data: [
		 * 					{
		 * 						attributes: <routeResources>,
		 * 						primaryKey: "routeID",
		 * 						realLevel: <realDepthLevelWithinTree>,
		 * 						level: <depthLevelWithinTreeRespectingMenuElements>, // routes which parents doesn't belong to the menu bubble up in a sense of depth-level
		 * 						sortKey: <routeTreeSortKey> // this sort key works for the whole routeTree as well as for subTrees
		 * 					},
		 * 					...
		 * 				]
		 * 			}
		 * 		}
		 * 	},
		 * 	...
		 * ]}}
		 */
		menus: function(resources, resourceConfig, storage){
			var result = { data: [] };
			var route;
			var routes = {};
			var routesBySortKeys = {};
			var routeParentsPerLevel = {};
			var routeLists = {};
			var sortedRouteKeys = {};
			var tags = {};
			var routeAttributes, routeID, tagCode, tagResult;

			// prepare route categories to know which ones are active (according to the inheritance logic) and which ones are not.
			var inheritedRouteCategories = utils.prepareTagCategoryInheritanceList(resources, resources.routeTags, 'parentRouteID', routeParentsPerLevel);

			// create a list of routes per menu-item (categoryData)
			utils.forEach(resources.data || [], function (route, routeIndex) {
				routeAttributes = route.attributes || {};
				routeID = routeAttributes[route.primaryKey];
				routes[routeID] = route;

				// prepare routes categories if they are nav-categories
				routeAttributes.categories = {};

				utils.prepareCategories(routeAttributes.categories, (route.children.cms_entities_categories || {}).data || [], storage, inheritedRouteCategories[routeID] || {});
				utils.forEach(routeAttributes.categories, function(category, categoryIndex){
					if(category.tagScopes.nav && !category.turnedOff && (!category.turnedOffByInheritance || category.turnedOn)){

						utils.forEach(category.children, function(tag, tagIndex){
							tagCode = ((tag || {}).resources || {}).value || 'UNKOWN_NAV_TAG_VALUE';

							// remember categoryData resources
							if(!tags[tagCode]){
								tags[tagCode] = tag.resources;
							}

							// remember routeID
							if(!routeLists[tagCode]) routeLists[tagCode] = {};
							routeLists[tagCode][routeID] = true;
						});
					}
				});
			});

			// prepare sortKeys which are valid across the whole routeTree
			utils.forEach(routeParentsPerLevel, function(routeLevels, routeID){
				if(routes[routeID]){
					routes[routeID].sortKey = [];
					routes[routeID].realLevel = utils.collectionSize(routeLevels);
					routes[routeID].level = routes[routeID].realLevel;
					utils.forEach(routeLevels, function(parentRouteID, level){
						// level 0 means root (virtual root of all nodes)
						if(level > 0 && (routes[parentRouteID] || {}).attributes){
							routes[routeID].sortKey.push(String(routes[parentRouteID].attributes.sort).padStart(16, '0'));
						}
					});
					routes[routeID].sortKey.push(String(((routes[routeID] || {}).attributes || {}).sort || 'UNKNOWN-OWN-SORT-KEY').padStart(16, '0'));
					routes[routeID].sortKey = routes[routeID].sortKey.join('-');
					routesBySortKeys[routes[routeID].sortKey] = routes[routeID];
				}
			});

			// sort routes within menu items
			utils.forEach(routeLists, function(routeList, tagCode){
				sortedRouteKeys[tagCode] = [];
				utils.forEach(routeList, function(isRouteWithinMenu, routeID){
					sortedRouteKeys[tagCode].push(routes[routeID].sortKey);
				});
				sortedRouteKeys[tagCode] = sortedRouteKeys[tagCode].sort();
			});

			// prepare result in right data format
			utils.forEach(sortedRouteKeys, function(routeList, tagCode){
				tagResult = {
					primaryKey: 'categoryDataID',
					attributes: tags[tagCode] || {},
					children: {
						cms_routes: {
							data: []
						}
					}
				};
				utils.forEach(routeList, function(sortKey){
					// calculate right level (according to position based on which items are within the menu) 
					route = routesBySortKeys[sortKey];
					routeID = route.attributes.routeID;
					route.level = route.realLevel;
					utils.forEach(routeParentsPerLevel[routeID], function(parentRouteID){
						if(parentRouteID > 0 && !(routeLists[tagCode] || {})[parentRouteID]){
							route.level--;
						}
					});

					tagResult.children.cms_routes.data.push(utils.simpleCopy(routesBySortKeys[sortKey]))
				});
				result.data.push(tagResult);
			});

			return result;
		},

		/**
		 * sort categoryData according to tagAssignment tree usage.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @returns {*}
		 */
		tagAssignmentSort: function(resources, resourceConfig, storage){
			var catData;
			utils.forEach(((((resources || {}).data || {}).children || {}).cms_tagScopes_categories || {}).data || [], function(tagScopeCategory, dataIndex){
				catData = (((((resources.data.children.cms_tagScopes_categories.data[dataIndex] || {}).children || {}).cms_categories || {}).data || {}).children || {}).catData;
				if(catData){
					utils.sortTreeResources(catData, 'parentCategoryDataID');
				}
			});

			return resources;
		},

		/**
		 * return entity list gathered by raw-query as it would be returned when dataQuery is used.
		 * NOTE: only one single level of elements is supported by this sanitizer.
		 * NOTE: primaryKey's name has to be defined within resourceConfig.sanitizerParams.primaryKey flag.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @returns {{data}}
		 */
		sanitizeSimpleRawQuery: function(resources, resourceConfig, storage){
			var primaryKey;
			if(!(primaryKey = ((resourceConfig || {}).sanitizerParams || {}).primaryKey)){
				return resources;
			}

			var dataIndex, record;
			var data = (resources || {}).data || [];
			var entityID, entityList = [];

			for(dataIndex in data){
				record = data[dataIndex];
				entityID = record[primaryKey];
				if(entityID){
					entityList.push({
						primaryKey: primaryKey,
						attributes: record
					});
				}
			}

			return {
				data: entityList
			};
		},

		/**
		 * return image list gathered by raw-query as it would be returned when dataQuery is used.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @returns {{data}}
		 */
		sanitizeCategorizedMedia: function(resources, resourceConfig, storage){
			var dataIndex, record;
			var data = (resources || {}).data || [];
			var mediaID, mediaList = [];
			var entityCategory, entityCategoryID, entityCategories = [];
			var entityRendered, entityRenderedID, entityRenderedList = [];
			var cms_categoriesData, children;

			for(dataIndex in data){
				record = data[dataIndex];
				mediaID = record.mediaID;
				if(mediaID){

					// handle categories
					entityCategories = [];
					for(entityCategoryID in record.cms_entities_categories){
						entityCategory = record.cms_entities_categories[entityCategoryID];
						cms_categoriesData = record.cms_entities_categories[entityCategoryID].cms_categoriesData;
						delete entityCategory.cms_categoriesData;

						entityCategories.push({
							primaryKey: 'entityCategoryID',
							attributes: entityCategory,
							children: {
								cms_categoriesData: {
									data: {
										primaryKey: 'categoryDataID',
										attributes: cms_categoriesData
									}
								}
							}
						});
					}
					delete record.cms_entities_categories;

					// handle rendered media
					if(record.fileType === 'image'){
						entityRenderedList = [];
						for(entityRenderedID in record.rendered || []){
							entityRendered = record.rendered[entityRenderedID];
							entityRenderedList.push({
								primaryKey: 'mediaRenderedID',
								attributes: record.rendered[entityRenderedID]
							});
						}
						delete record.rendered;
					}

					children = {
						cms_entities_categories: {
							// sort categories by categoryDataID to ensure tags being sent in a specific order to the client
							data: entityCategories.sort(function(a, b){
								if(a.attributes.categoryDataID === b.attributes.categoryDataID) return 0;
								if(a.attributes.categoryDataID < b.attributes.categoryDataID) return -1;
								return 1;
							})
						}
					};
					if(record.fileType === 'image'){
						children.cms_mediaRendered = {
							data: entityRenderedList
						};
					}

					mediaList.push({
						primaryKey: 'mediaID',
						attributes: record,
						children: children
					});
				}
			}

			return {
				data: mediaList
			};
		},

		/**
		 * return counter data gathered by raw-query as it would be returned when dataQuery is used.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @returns {{data}}
		 */
		sanitizeFilterCounters: function(resources, resourceConfig, storage){
			var nonMatchingIndex = 0;
			var matchingIndex = 1;
			if(((resources.data || [])[0] || {}).filtersMatching){
				nonMatchingIndex = 1;
				matchingIndex = 0;
			}
			var result = {
				data: {
					attributes: {
						nrOfNonMatchingElements: parseInt(((resources.data || [])[nonMatchingIndex] || {}).nrOfElements) || 0,
						nrOfMatchingElements: parseInt(((resources.data || [])[matchingIndex] || {}).nrOfElements) || 0,
						sizeOfNonMatchingElements: parseInt(((resources.data || [])[nonMatchingIndex] || {}).sizeInBytes) || 0,
						sizeOfMatchingElements: parseInt(((resources.data || [])[matchingIndex] || {}).sizeInBytes) || 0
					}
				}
			};
			result.data.attributes.nrOfElements = result.data.attributes.nrOfMatchingElements + result.data.attributes.nrOfNonMatchingElements;
			result.data.attributes.sizeOfElements = result.data.attributes.sizeOfMatchingElements + result.data.attributes.sizeOfNonMatchingElements;
			return result;
		},
	},

	set: {

		/**
		 * sanitize render image calls.
		 *
		 * @param resources
		 * @param resourceConfig
		 * @param storage
		 * @return {*}
		 */
		renderImage: function(resources, resourceConfig, storage){
			if(storage.app && storage.app.service && storage.app.service.config){
				// merge with defaultRenderConfig
				if(storage.app.service.config.media && storage.app.service.config.media.defaultRenderConfigs){
					if(resources.type === 'dynamic' && storage.app.service.config.media.defaultRenderConfigs.imageDynamic){
						resources = utils.simpleMerge(storage.app.service.config.media.defaultRenderConfigs.imageDynamic, resources);
					}
					else if(storage.app.service.config.media.defaultRenderConfigs.imageFixed){
						resources = utils.simpleMerge(storage.app.service.config.media.defaultRenderConfigs.imageFixed, resources);
					}
				}

				// sanitize device and breakpoint according to serviceConfig.layout
				var layout;
				if(storage.app.webService && storage.app.webService.config && storage.app.webService.config.media && storage.app.webService.config.media.layout) {
					layout = storage.app.webService.config.media.layout;
				}
				if(resources.device){
					if(!layout || !layout[resources.device]){
						// TODO: THROW ERROR VS IGNORE
						resources.device = undefined;
						resources.breakPoint = undefined;
					}
					else if(resources.breakPoint){
						if(!layout[resources.device][resources.breakPoint]){
							// TODO: THROW ERROR VS IGNORE
							resources.breakPoint = undefined;
						}
					}
				}
				else if(resources.breakPoint) {
					// TODO: THROW ERROR VS IGNORE
					resources.breakPoint = undefined;
				}
			}

			return resources;
		}
	}
};

module.exports = {
	initialized: false,

	/**
	 * this function is used to initialize the sanitizers
	 * NOTE: afterwards this object cannot be changed.
	 *
	 * @params  useCaseSanitizers       {} - this object can container get- and set-sanitizers which should be available afterwards.
	 * @return  {} - self
	 */
	init: function(useCaseSanitizers){
		if(!this.initialized){
			var sanitizerType;
			for(sanitizerType in useCaseSanitizers){
				utils.refReplace(sanitizers[sanitizerType], useCaseSanitizers[sanitizerType]);
			}
			for(sanitizerType in defaultSanitizers){
				utils.refReplace(sanitizers[sanitizerType], defaultSanitizers[sanitizerType]);
			}
			this.initialized = true;
		}

		return this;
	},

	/**
	 * this function is used to sanitize the given resources according to the given resourceConfig and storage.
	 * NOTE:    if the resourceConfig is not given or contains no "sanitizerID" flag or the sanitizer-function cannot be found,
	 *          the plain resources will be returned.
	 *
	 * @param   resources           mixed - actual resources
	 * @param   resourceConfig      {} - actual resourceConfig (if this is not an object the sanitizerID can be given)
	 * @param   storage             {} - actual storage
	 * @return  mixed - resources
	 */
	sanitizeComponent: function(resources, resourceConfig, storage){
		// set shortcut for sanitizers if necessary
		if(!utils.isCollection(resourceConfig)) resourceConfig = { sanitizerID: resourceConfig };
		if(resourceConfig && resourceConfig.sanitizerID && utils.isFunction(sanitizers.component[resourceConfig.sanitizerID])){
			resources = sanitizers.component[resourceConfig.sanitizerID].apply(this, arguments);
		}
		return resources;
	},

	/**
	 * this function is used to sanitize the given resources according to the given resourceConfig and storage.
	 * NOTE:    if the resourceConfig is not given or contains no "sanitizerID" flag or the sanitizer-function cannot be found,
	 *          the plain resources will be returned.
	 *
	 * @param   resources           			mixed - actual resources
	 * @param   resourceConfig      			{} - actual resourceConfig (if this is not an object the sanitizerID can be given)
	 * @param   storage             			{} - actual storage
	 * @param   preExecution					boolean - should the sanitizer be executed before the request will be sent
	 * @param   preDataStructureExecution		boolean - should the sanitizer be executed before the dataStructure preparation takes place
	 * @return  mixed - resources
	 */
	sanitizeGet: function(resources, resourceConfig, storage, preExecution, preDataStructureExecution){
		// set shortcut for sanitizers if necessary
		var executionGroupKey = 'get';
		if(preExecution) executionGroupKey = 'preGet';
		if(preDataStructureExecution) executionGroupKey = 'preDataStructure';
		if(!utils.isCollection(resourceConfig)) resourceConfig = { sanitizerID: resourceConfig };
		if(resourceConfig && resourceConfig.sanitizerID && utils.isFunction(sanitizers[executionGroupKey][resourceConfig.sanitizerID])){
			resources = sanitizers[executionGroupKey][resourceConfig.sanitizerID].apply(this, arguments);
		}
		return resources;
	},

	/**
	 * this function is used to sanitize the given resources according to the given resourceConfig and storage.
	 * NOTE:    if the resourceConfig is not given or contains no "sanitizerID" flag or the sanitizer-function cannot be found,
	 *          the plain resources will be returned.
	 *
	 * @param   resources           mixed - actual resources
	 * @param   resourceConfig      {} - actual resourceConfig (if this is not an object the sanitizerID can be given)
	 * @param   storage             {} - actual storage
	 * @param   dataStructure       {} - actual requests data structure (default: {})
	 * @param   options				{} - optional - contains meta information like method (http-method), ...
	 * @return  mixed - resources
	 */
	sanitizeSet: function(resources, resourceConfig, storage, dataStructure, options){
		// set shortcut for sanitizers if necessary
		var executionGroupKey = 'set';
		if(!utils.isCollection(resourceConfig)) resourceConfig = { sanitizerID: resourceConfig };
		if(resourceConfig && resourceConfig.sanitizerID && utils.isFunction(sanitizers[executionGroupKey][resourceConfig.sanitizerID])){
			resources = sanitizers[executionGroupKey][resourceConfig.sanitizerID].apply(this, arguments);
		}
		return resources;
	}
};
